import { render, staticRenderFns } from "./KarafunDevice.vue?vue&type=template&id=2cc36c80"
import script from "./KarafunDevice.vue?vue&type=script&lang=js"
export * from "./KarafunDevice.vue?vue&type=script&lang=js"
import style0 from "./KarafunDevice.vue?vue&type=style&index=0&id=2cc36c80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports